import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { ScriptService } from 'ngx-captcha';

declare var grecaptcha: any;

@Component({
  selector: 'app-descriptive-text',
  templateUrl: './descriptive-text.component.html',
  styleUrls: ['./descriptive-text.component.css'],
})
export class DescriptiveTextComponent implements OnInit, OnChanges, OnDestroy {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() isDarkTheme: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  questions: Questions;
  isRTL: boolean;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  theme: string;
  isqtitlelarge: boolean;
  isAnsChange: boolean = false;
  isAnsSelectedLang:string = 'en';
  private languageCheckInterval: any;
  private captchaWidgetId: number | null = null;

  constructor(
    private service: ParticipationDataService, 
    private changeDetect: ChangeDetectorRef,
    private scriptService: ScriptService
  ) {}

  ngOnInit() {
    this.isAnsSelectedLang = this.service.getSelectedLanguageCulture();
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      if (this.questions?.qsubtype == 1) {
        this.questions.AnswerText = null;
        this.ChangeLoadingAnswersData.emit(this.questions);
        this.isAnsChange = false;
      }
    }

    if (this.isDarkTheme) {
      this.theme = 'dark';
    } else {
      this.theme = 'light';
    }

    this.isRTL = this.service.getRTL();
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    if (
      (this.questions?.qtitle.length > 50 ||
        (this.questions?.qtitle.match(/<br \/>/g) || []).length > 1) &&
      this.surveyFormat == 2
    ) {
      this.isqtitlelarge = true;
    }

    // Start checking for language changes if this is a captcha component
    if (this.questions?.qsubtype == 1) {
      this.startLanguageCheck();
      this.initializeCaptcha();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.isDarkTheme != undefined &&
      changes.isDarkTheme.currentValue != changes.isDarkTheme.previousValue
    ) {
      if (this.isDarkTheme) {
        this.theme = 'dark';
      } else {
        this.theme = 'light';
      }
    }
  }

  ngOnDestroy() {
    if (this.languageCheckInterval) {
      clearInterval(this.languageCheckInterval);
    }
    // Clean up captcha widget
    if (this.captchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
      try {
        grecaptcha.reset(this.captchaWidgetId);
      } catch (e) {
        console.warn('Error cleaning up captcha:', e);
      }
    }
  }

  private startLanguageCheck() {
    this.languageCheckInterval = setInterval(() => {
      const currentLanguage = this.service.getSelectedLanguageCulture();
      if (currentLanguage && currentLanguage !== this.isAnsSelectedLang) {
        this.isAnsSelectedLang = currentLanguage;
        this.updateCaptchaLanguage();
        this.changeDetect.detectChanges();
      }
    }, 1000); // Check every second
  }

  private initializeCaptcha() {
    // Check if grecaptcha is already available
    if (typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.render) {
      this.renderCaptcha();
      return;
    }
    
    // Use ScriptService to ensure reCAPTCHA script is loaded
    this.scriptService.registerCaptchaScript(
      {
        useGlobalDomain: false
      },
      'explicit',
      (grecaptcha) => {
        this.renderCaptcha();
      },
      this.isAnsSelectedLang
    );
  }

  private renderCaptcha() {
    if (typeof grecaptcha === 'undefined' || !grecaptcha) {
      return;
    }

    try {
      const container = document.getElementById('captcha-container');
      if (!container) {
        setTimeout(() => {
          this.renderCaptcha();
        }, 100);
        return;
      }

      // Clear any existing content
      container.innerHTML = '';
      
      const renderOptions = {
        sitekey: this.questions.dataSecretKey,
        theme: this.theme,
        hl: this.isAnsSelectedLang,
        callback: (response: string) => {
          this.resolved(response);
        }
      };
      
      this.captchaWidgetId = grecaptcha.render(container, renderOptions);
    } catch (error) {
      console.error('Error rendering captcha:', error);
    }
  }

  private updateCaptchaLanguage() {
    if (typeof grecaptcha === 'undefined' || !grecaptcha || !grecaptcha.render) {
      return;
    }

    try {
      const container = document.getElementById('captcha-container');
      if (!container) {
        setTimeout(() => {
          this.updateCaptchaLanguage();
        }, 100);
        return;
      }

      // Remove the previous captcha widget
      if (this.captchaWidgetId !== null) {
        grecaptcha.reset(this.captchaWidgetId);
      }

      // Re-render the captcha with the new language
      this.renderCaptcha();
    } catch (error) {
      console.error('Error updating captcha language:', error);
    }
  }

  resolved(captchaResponse: string) {
    if (captchaResponse != null || captchaResponse != '') {
      this.questions.AnswerText = 'Captcha Success';
      this.ChangeAnswersData.emit(this.questions);
      this.isAnsChange = true;
    }
  }

  gotoNextQuestion(question: Questions, event) {
    this.service.gotoNextQuestion(question, event);
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }
}
